import { Lock, ExternalLink, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BookAPrivateSession() {
  return <section data-section-id="222819" id="kontakt" className="dark bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background border-none rounded-none p-8 md:p-12 lg:p-16 text-center shadow-none relative overflow-hidden">
          {}
          <div className="absolute top-0 left-0 w-full h-px bg-foreground/10 opacity-20" />

          <div className="mx-auto w-16 h-16 bg-transparent rounded-none flex items-center justify-center mb-6 border-none">
            <Mail className="w-8 h-8 text-primary" strokeWidth={1} />
          </div>

          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-medium mb-6 text-foreground tracking-tight">
            Join the Flow
          </h2>

          <div className="max-w-2xl mx-auto space-y-6 mb-10">
            <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed">
              Abonnieren Sie den Newsletter für neue Essays und philosophische Impulse direkt in Ihr Postfach.
            </p>
            <div className="bg-transparent border-b border-foreground/20 rounded-none p-6 text-left">
              <h3 className="font-default text-lg font-medium text-foreground mb-2 flex items-center gap-2">
                <span className="flex items-center justify-center w-6 h-6 rounded-none bg-primary text-primary-foreground text-xs font-bold">i</span>
                Kontakt & Impressum
              </h3>
              <p className="font-default text-muted-foreground text-sm opacity-60">
                Gedankengänge Blog • Zürich, Schweiz • Alle Texte sind persönliche Reflexionen und unterliegen dem Urheberrecht.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-transparent hover:bg-transparent text-foreground border-b border-foreground rounded-none hover:opacity-70 transition-opacity">
              <Link to="/HomePage">
                Newsletter abonnieren
                <ExternalLink className="w-4 h-4 ml-2" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-12 px-8 border-none bg-transparent text-muted-foreground hover:text-foreground hover:bg-transparent">
              <Link to="mailto:hallo@gedankenfluss.ch">
                <Mail className="w-4 h-4 mr-2" />
                Direkter Kontakt
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}